// frontend/src/components/OrdersPage/OrderFinances/utils.js

import { BASE_URL, PAYMENT_STATUS_OPTIONS } from "./constants";

export const getList = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.results)) return data.results;
  if (Array.isArray(data?.data)) return data.data;
  return data && typeof data === "object" ? [data] : [];
};

export const formatDate = (date) => {
  if (!date) return "—";
  const parsed = new Date(date);
  if (Number.isNaN(parsed.getTime())) return date;
  return parsed.toLocaleDateString("ru-RU");
};

export const formatMoney = (value) =>
  Number(value || 0).toLocaleString("ru-RU", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const formatPaymentStatus = (status) => {
  const option = PAYMENT_STATUS_OPTIONS.find((item) => item.value === status);
  return option?.label || status || "—";
};

export const getDocumentUrl = (document) => {
  const url = document?.file_url || document?.file;
  if (!url) return null;
  if (/^https?:\/\//i.test(url)) return url;
  return `${BASE_URL}${url.startsWith("/") ? "" : "/"}${url}`;
};

export const getErrorMessage = async (response, fallback) => {
  try {
    const data = await response.json();

    if (typeof data === "string") return data;
    if (data?.error) {
      return typeof data.error === "string"
        ? data.error
        : JSON.stringify(data.error, null, 2);
    }
    if (data?.detail) {
      return typeof data.detail === "string"
        ? data.detail
        : JSON.stringify(data.detail, null, 2);
    }

    return (
      Object.entries(data || {})
        .map(([key, value]) => {
          const message =
            typeof value === "string"
              ? value
              : JSON.stringify(value, null, 2);
          return `${key}: ${message}`;
        })
        .join("\n") || fallback
    );
  } catch {
    return fallback;
  }
};

// Сумма комиссии с символом валюты (используется в строке таблицы).
export const formatCommissionAmount = (commission) => {
  const symbol = commission?.currency_symbol || "";
  const amount = formatMoney(commission?.amount);
  return symbol ? `${symbol} ${amount}` : amount;
};